<template>
  <div class="stock-trace-main">
    <el-card class="stock-trace-filters">
      <el-row type="flex" justify="space-between">
        <el-col :span="18">
          <el-row type="flex" justify="start">
            <el-col :span="12">
              <el-date-picker v-model="timeRange" type="datetimerange" format="yyyy-MM-dd HH:mm:ss" placeholder="el-select date and time" size="large">
              </el-date-picker>
            </el-col>
            <!-- <el-col :span="6">
              <el-select v-model="actionType" size="large" placeholder="Action Type" clearable>
                <el-option v-for="item in actionTypeList" :value="item" :key="item">{{ item }}</el-option>
              </el-select>
            </el-col> -->
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row>
            <span style="margin: 0 10px;">
              <el-button @click="searchPage" type="primary" icon="search" size="large">Search</el-button>
            </span>
            <el-button @click="clearFilters" type="ghost" size="large">Reset</el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-card>
      <el-table :data="stockTraceData">
        <el-table-column prop="timeStr" label="操作时间" min-width="100">
        </el-table-column>
        <el-table-column prop="sourceType" label="操作类型" min-width="100"></el-table-column>
        <el-table-column prop="orderNo" label="订单编号" min-width="80"></el-table-column>
        <el-table-column prop="version" label="版本号" min-width="80">
        </el-table-column>
        <el-table-column prop="store" label="商家库存" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span v-if='scope.row.dlStockResultDTO'  class="manipulate">{{scope.row.dlStockResultDTO.boutiqueStock}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reserved" label="可售库存" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span v-if='scope.row.dlStockResultDTO'  class="manipulate">{{scope.row.dlStockResultDTO.stock}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="confirmed" label="冻结库存" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span v-if='scope.row.dlStockResultDTO' class="manipulate">{{scope.row.dlStockResultDTO.imReserved}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="locked" label="商家冻结" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span v-if='scope.row.dlStockResultDTO' class="manipulate">{{scope.row.dlStockResultDTO.boutiqueReserved}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="locked" label="同步销售层" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span v-if='scope.row.dlStockResultDTO' class="manipulate">{{scope.row.dlStockResultDTO.stockChanged==true?'Y':'N'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="locked" label="同步库存" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span  v-if='scope.row.slStockResultDTO' class="manipulate">{{scope.row.slStockResultDTO.boutiqueStock}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="locked" label="可售库存" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span v-if='scope.row.slStockResultDTO' class="manipulate">{{scope.row.slStockResultDTO.store}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="locked" label="冻结库存" min-width="60">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span v-if='scope.row.slStockResultDTO' class="manipulate">{{scope.row.slStockResultDTO.reserved}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="action" label="操作" min-width="120">
          <template slot-scope="scope" style="display:flex;flex-direction:row">
            <span v-if="scope.row['content.requestId']==''" class="manipulate">no original data</span>
            <el-button v-else type="primary" size="small" class="manipulate" @click.stop="popOriginalData(scope.row['content.requestId'])">original data</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-button v-if="context" type="primary" style="width: 100%;margin-top: 20px" plain @click="loadMore">加载下一页</el-button>

    </el-card>
    <Modal v-model="isOrgDataVisable" title="Original Data" @on-cancel="cancelData">
      <div style="word-wrap:break-word">{{originalData}}</div>
    </Modal>
  </div>
</template>
<script>
import util from "@/utils/util";
import * as TraceService from "@/api/trace";
export default {
  data() {
    return {
      skuId: 0,
      originalData: "",
      isOrgDataVisable: false,
      pageSize: 20,
      currentPage: 1,
      timeRange: [],
      actionType: "",
      actionTypeList: [],
      stockTraceData: [],
      context: '', // 查询日志参数
    }
  },
  mounted() {
    this.skuId = this.$route.params.skuId;
    this.initTimeRange();
    this.refreshTable();
  },
  methods: {
    initTimeRange() {
      let end = new Date().getTime();
      let start = end - 60 * 60 * 1000 * 24 * 30;
      this.timeRange = [new Date(start), new Date(end)];
    },

    popOriginalData(requestId) {
      this.isOrgDataVisable = true;

      TraceService.getOrgData(requestId).then(res => {
        if (res.data.status === 1) {
          this.originalData = res.data.data;
        } else {
          this.$message(res.data.data);
        }
      })
    },
    refreshTable() {
      this.loading = true;
      let param = {
        from: this.timeRange[0].getTime(),
        to: this.timeRange[1].getTime(),
        context: this.context,
        limit: this.pageSize
      };
      TraceService.getSkuNewStockTrace(this.skuId, param).then(res => {
        this.loading = false;
        console.log(res);
        if (res.data.status === 1) {
          this.stockTraceData = [...this.stockTraceData, ...res.data.data.datas];
          this.context = res.data.data.context;
        } else {
          this.$message(res.data.data);
        }
      })
    },
    loadMore() {
      if (this.loading) {
        return;
      }
      if (!this.context) {
        return;
      }
      this.refreshTable();
    },
    searchPage() {
      if (this.loading) {
        return;
      }
      this.context = '';
      this.stockTraceData = [];
      this.refreshTable();

    },
    clearFilters() {
      this.currentPage = 1;
      this.stockTraceData = [];
      this.actionType = "";
    },
    cancelData() {

    }
  }
}

</script>
<style lang="less">
.pagePos {
  margin-top: 20px;
  transform: translateX(60%);
}
@import "./stock-trace.less";
@import "../../../styles/common.less";
</style>